"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/LYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_142)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_142`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.7473 10.5754L14.3789 11.4386L15.3965 11.1088L14.7649 11.9789L15.3965 12.8421L14.3789 12.5123L13.7473 13.3754V12.3088L12.7298 11.9789L13.7473 11.6491V10.5754Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0351 14.1404C10.8421 14.1404 9.86666 13.172 9.86666 11.972C9.86666 10.772 10.8351 9.80354 12.0351 9.80354C12.407 9.80354 12.7579 9.89477 13.0667 10.0632C12.5824 9.59302 11.9298 9.3053 11.2 9.3053C9.72631 9.3053 8.53333 10.4983 8.53333 11.972C8.53333 13.4456 9.72631 14.6386 11.2 14.6386C11.9228 14.6386 12.5824 14.3509 13.0667 13.8807C12.7579 14.0492 12.407 14.1404 12.0351 14.1404Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_142`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as LYFlag };
